export const COMMON_LOGGEDOUT = 'redux/commonTypes/COMMON_LOGGEDOUT'
export const COMMON_LOGGEDIN = 'redux/commonTypes/COMMON_LOGGEDIN'
